import { auditReports } from '@mi-front/api-clients';
import { DateStr, Station, today } from '@mi-front/core';
import { useTimezone } from '../../../../../../core/hooks';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { BcrMatchesReportForm } from './form';
import { BcrMatchesReportResult } from './result';
import { BcrMatchesReport } from './types';

export function BcrMatchesReportView(p: { station: Station }) {
  const tz = useTimezone();

  const resetValues = {
    date: today() as DateStr,
  };

  return (
    <ReportView<BcrMatchesReport>
      defaultValues={resetValues}
      reportFn={(values) => {
        return auditReports.executeBcrMatchesReport({
          stationId: p.station.slug,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={BcrMatchesReportForm}
      Result={BcrMatchesReportResult}
    />
  );
}
